import Nullable from "./utils/Nullable";

interface ISignatureResponsavel{
    tipo_documento: string,
    nome: string,
    sobrenome: string,
    email: string,
    genero?: Nullable<string>,
    documento: string,
    telefone?: Nullable<string>,
    celular: string,
    data_nascimento?: Nullable<string>
}

export const instanceOfISignatureResponsavel = (object: any) : object is ISignatureResponsavel =>{
    return 'tipo_documento' in object &&
        'nome' in object &&
        'sobrenome' in object &&
        'email' in object &&
        'documento' in object &&
        'celular' in object
}

export default ISignatureResponsavel